var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"progressbar",style:({width: _vm.progress+'%'})})])])
}
var staticRenderFns = []

export { render, staticRenderFns }